export enum OrchestradeBookingMode {
  auto = 'automatic',
  manual = 'manual',
  noOTBooking = 'no_ot_booking',
}

export enum OrchestradeEventType {
  contractSigned = 'CONTRACT_SIGNED',
}

export enum OrchestradeState {
  inProgress = 'IN_PROGRESS',
  nothingToBook = 'NOTHING_TO_BOOK',
  succeeded = 'SUCCEEDED',
  failed = 'FAILED',
  waitingTasResponse = 'WAITING_TAS_RESPONSE',
}
